import styled from 'styled-components'

export const ToastLink = styled.button`
    margin-left: 8px;
    border: 0;
    background-color: transparent;
    color: #0037ff;
    font-size: 0.75rem;
    text-decoration: underline;
    cursor: pointer;
    font-family: Montserrat;

    &:disabled {
        color: ${({ theme }) => theme.colors.grays[50]};
        cursor: default;
    }
`
